var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurePack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M10.6,35.6c-0.1,1,0.7,1.8,1.7,1.9c0.1,0,0.1,0,0.2,0h20c1,0,1.9-0.9,1.9-1.9c-0.1-1-0.9-1.8-1.9-1.9v-2.4 h1.2V30h-1.2V15h1.2v-1.3h-1.2v-2.4c1-0.1,1.8-0.9,1.9-1.9c0-1-0.9-1.9-1.9-1.9h-20c-1-0.1-1.8,0.7-1.9,1.7c0,0.1,0,0.1,0,0.2 c0,1,0.9,1.9,1.9,1.9v2.4h-1.3V15h1.3v15h-1.3v1.3h1.3v2.4C11.5,33.7,10.6,34.6,10.6,35.6z M15,35v-1.3h-1.3v-2.4H15V30h-1.3V15H15 v-1.3h-1.3v-2.4H15V10h-2.5c-0.4,0-0.6-0.3-0.7-0.6c0-0.4,0.3-0.7,0.7-0.7h20c0.3,0.1,0.6,0.3,0.6,0.7c0,0.3-0.3,0.6-0.6,0.6H16.2 v1.3h15v2.4h-15V15h15v15h-15v1.3h15v2.4h-15V35h16.3c0.3,0,0.6,0.3,0.6,0.6c0,0.4-0.3,0.6-0.6,0.7h-20c-0.4,0-0.7-0.3-0.7-0.7 c0.1-0.3,0.3-0.6,0.7-0.6H15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M11.8,35.6c0,0.4,0.3,0.7,0.7,0.7h20c0.3-0.1,0.6-0.3,0.6-0.7c0-0.3-0.3-0.6-0.6-0.6H16.2v-1.3h15v-2.4h-15 V30h15V15h-15v-1.3h15v-2.4h-15V10h16.3c0.3,0,0.6-0.3,0.6-0.6c0-0.4-0.3-0.6-0.6-0.7h-20c-0.4,0-0.7,0.3-0.7,0.7 c0.1,0.3,0.3,0.6,0.7,0.6H15v1.3h-1.3v2.4H15V15h-1.3v15H15v1.3h-1.3v2.4H15V35h-2.5C12.1,35,11.9,35.3,11.8,35.6z M19.3,25 l2.4-4.8c0.3-0.5,0.8-0.7,1.3-0.5c0.2,0.1,0.4,0.3,0.5,0.6l2.4,4.8c0.2,0.5,0,1-0.5,1.3h-5.2c-0.6,0-1-0.4-1-1 C19.2,25.2,19.3,25.1,19.3,25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M20.2,26.4h5.2c0.5-0.3,0.7-0.8,0.5-1.3l-2.4-4.8c-0.1-0.3-0.3-0.5-0.5-0.6c-0.5-0.2-1,0-1.3,0.5L19.3,25 c0,0.1-0.1,0.2-0.1,0.4C19.2,26,19.6,26.4,20.2,26.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurePack);
export default __webpack_public_path__ + "static/media/pure_pack.8f910b7a25e58bf1c7735297dd838dc3.svg";
export { ForwardRef as ReactComponent };